import styled from 'styled-components';

export const BackofficeNavWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  min-height: 60px;
  position: fixed;
  right: 50px;
  top: 120px;
  @media (max-width: 1030px) {
    flex-direction: column;
  }
`;
